export default __webpack_public_path__ + "static/media/bg02.70d825ea.jpg";